import { render } from "./IngresoMasivoProfesor.vue?vue&type=template&id=26fcc394&scoped=true"
import script from "./IngresoMasivoProfesor.vue?vue&type=script&lang=js"
export * from "./IngresoMasivoProfesor.vue?vue&type=script&lang=js"

import "./IngresoMasivoProfesor.vue?vue&type=style&index=0&id=26fcc394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fcc394"]])

export default __exports__